<template>
  <v-app-bar
    class="HeaderAppDesktop mx-auto my-3 hidden-sm-and-down"
    :max-width="maxWidth"
    color="transparent"
    dense
    dark
    flat
  >
    <v-img
      class="logo"
      contain
      :src="logo"
      max-width="200px"
    />
    <div
      v-if="adminHeader"
      class="ml-16"
    >
      <RouterLink
        v-for="(item, index) in list"
        :key="index"
        v-slot="{ isActive }"
        :to="{ name: item.to }"
        custom
      >
        <v-btn
          v-ripple="false"
          text
          depressed
          :to="{ name: item.to }"
          :class="{
            activeBtn: isActive,
            inactive: !isActive,
          }"
          class="btn-wesave"
        >
          <span> {{ item.label }} </span>
        </v-btn>
      </RouterLink>
    </div>
    <v-spacer />
    <div
      v-if="showValidateButton"
      class="d-flex align-center justify-center"
    >
      <HeaderCompletion
        v-if="customerFileCompletion.toFixed(0) < 100"
        class="my-6 mr-6"
        :completion="customerFileCompletion.toFixed(0)"
      />
      <v-btn
        :disabled="customerFileCompletion.toFixed(0) < 100"
        text
        class="theme-btn app-button-success nice-padding mr-6"
        @click="alertDialog = true"
      >
        {{ $t('subscription.validation.btn') }}
      </v-btn>
    </div>
    <v-divider
      class="header-divider"
      vertical
      inset
    />
    <v-btn
      v-ripple="false"
      class="btn-wesave no-padding"
      text
      @click="onClickLogout"
    >
      <img
        alt=""
        :src="'./assets/icons/logout.png'"
        class="picto"
      />
    </v-btn>
    <WeDialog
      :isDisplay.sync="alertDialog"
      imgUrl="add-doc.svg"
      title="subscription.validation.alert.title"
      description="subscription.validation.alert.description"
    >
      <v-btn
        text
        class="theme-btn app-button-primary color nice-padding"
        @click="redirectToValidation"
      >
        {{ $t('subscription.validation.btn') }}
      </v-btn>

      <v-btn
        text
        class="theme-btn app-button-secondary color-white nice-padding mt-2"
        @click="alertDialog = false"
      >{{ $t('common.action.later') }}</v-btn>
    </WeDialog>
  </v-app-bar>
</template>

<script>
  import CommonMixin from '@/mixins/store/CommonMixin'
  import WeDialog from '@/components/ui/common/Dialog/Dialog'

  import ApiService from '@/services/ApiService'
  import HeaderCompletion from '@/components/ui/partials/HeaderApp/HeaderCompletion/HeaderCompletion'
  import { PERSON_STATUS } from '@/services/models.const'

  export default {
    components: {
      HeaderCompletion,
      WeDialog,
    },
    mixins: [CommonMixin,],
    props: {
      logo: {
        type: String,
        required: true,
      },
      maxWidth: {
        type: Number,
        required: true,
      },
      adminHeader: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        alertDialog: false,
        list: [],
      }
    },
    computed: {
      showValidateButton() {
        if (this.$route.name === 'Validation') {
          return false
        }

        return (
          !this.adminHeader &&
          [PERSON_STATUS.created, PERSON_STATUS.pending,].includes(this.currentUser.meta.customer_file_status)
        )
      },
    },
    watch: {
      customerFileCompletion() {
        this.showValidationModal()
      },
    },
    mounted() {
      this.showValidationModal()
    },
    methods: {
      showValidationModal() {
        if (this.alertDialog) return
        if (
          this.customerFileCompletion === 100 &&
          this.$route.name !== 'Validation' &&
          !this.adminHeader &&
          [PERSON_STATUS.created, PERSON_STATUS.pending,].includes(this.currentUser.meta.customer_file_status)
        ) {
          this.alertDialog = true
        }
      },
      async onClickLogout() {
        if (localStorage.getItem('access_token')) {
          const result = await ApiService.logout(localStorage.getItem('access_token'))
          if (result.errors) {
            this.$message({
              type: 'error',
              text: 'logout_error',
            })
          } else {
            localStorage.clear()
            const path = this.$route.path
            const name = path.match(/crm/) ? 'LoginCRM' : 'Login'
            const loginRoute = { name, }
            this.$router.push(loginRoute)
          }
        } else {
          this.$message({
            type: 'error',
            text: 'logout_error',
          })
        }
      },
      redirectToValidation() {
        this.$router.push({ name: 'Validation', })
        this.alertDialog = false
      },
    },
  }
</script>

<style scoped lang="scss">
.HeaderApp {
  top: 0;
  position: fixed;
  width: 100%;
  padding: 8px 0;
  z-index: 1000;
  font-weight: 400;
  font-size: 1em;
  background-color: $color-102d69 !important;
  box-shadow: inset 0 -2px 0 0 $color-ffd300, 0 16px 32px 0 $color-31_54_139_12;
  .logo {
    margin-left: 2.5rem;
  }
  .picto {
    width: 40px;
    height: 40px;
  }

  .header-divider {
    background-color: $color-020d24;
    height: 28px;
    opacity: 80%;
    width: 2px;
    margin-top: 10px;
  }
}
@media (max-width: 600px) {
  .headerApp {
    width: 100%;
  }
}
</style>
